import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TitleCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HomeGridComponent } from '../home-grid/home-grid.component';
import { UserContextService } from '../../services/user-context.service';
import { ThemeService } from '../../services/theme.service';

/**
 * Mobile "Plus" / account hub (the 4th bottom-bar tab).
 * Groups: the logged-in identity, the internal member search, the full rubric grid,
 * and the account actions (language, theme, logout).
 */
@Component({
  selector: 'myabvv-mobile-plus',
  standalone: true,
  templateUrl: './mobile-plus.component.html',
  styleUrl: './mobile-plus.component.css',
  imports: [RouterLink, RouterLinkActive, TitleCasePipe, TranslatePipe, HomeGridComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobilePlusComponent {
  userContext = inject(UserContextService);
  theme = inject(ThemeService);


  toggleDarkMode(): void {
    this.theme.toggleDarkMode();
  }

  logout(): void {
    this.userContext.logout();
  }
}
